import { localStorageAdapter } from "../LocalStorageAdapter";
import { FetchAdapter } from "../FetchAdapter/FetchAdapter";
import { BugsnagAdapter } from "../BugsnagAdapter/BugsnagAdapter";

const _localStore = localStorageAdapter("vidio_api_key");

export class ApiKey {
  static async getApiKey() {
    let token;

    try {
      token = ApiKey.getToken();

      if (!token || ApiKey.isExpired()) {
        let fetchedData = await ApiKey.fetchToken();
        let expiryDate = fetchedData["api_key_expires_at"];
        let accessExpiryDate = fetchedData["access_token_expires_at"];
        let refreshExpiryDate = fetchedData["refresh_token_expires_at"];

        token = fetchedData["api_key"];

        ApiKey.setToken(token);
        ApiKey.setExpiry(expiryDate);
        ApiKey.setAccessExpiry(accessExpiryDate);
        ApiKey.setRefreshExpiry(refreshExpiryDate);
      }

      return token;
    } catch (e) {
      const err = e instanceof Error ? e : new Error(`/auth is aborted`);
      BugsnagAdapter.notify("ApiKey::getApiKey", err, e);
      return token || null;
    }
  }

  static isExpired() {
    try {
      let apiKeyExpired = ApiKey.getExpiry();
      let refreshExpired = ApiKey.getRefreshExpiry();
      let accessExpired = ApiKey.getAccessExpiry();

      return (
        ApiKey.durationSinceExpired(refreshExpired) <= 0 ||
        ApiKey.durationSinceExpired(accessExpired) <= 0 ||
        ApiKey.durationSinceExpired(apiKeyExpired) <= 0
      );
    } catch (e) {
      BugsnagAdapter.notify("ApiKey::isExpired", e);
      return true;
    }
  }

  static durationSinceExpired(expiryDate) {
    const OFFSET_TIME = 2;

    if (expiryDate) {
      const dateExpires = new Date(expiryDate);
      const dateNow = new Date(Date.now());
      dateNow.setHours(dateNow.getHours() + OFFSET_TIME);

      return dateExpires - dateNow;
    } else {
      return 0;
    }
  }

  static async fetchToken() {
    const response = await FetchAdapter.post("/auth");
    return response.json();
  }

  static setToken(data) {
    _localStore.setItem("common_api_key_token", data);
  }

  static getToken() {
    return _localStore.getItem("common_api_key_token");
  }

  static setExpiry(date) {
    _localStore.setItem("common_api_key_expiry", date);
  }

  static getExpiry() {
    return _localStore.getItem("common_api_key_expiry");
  }

  static setRefreshExpiry(date) {
    _localStore.setItem("refresh_token_expiry", date);
  }

  static getRefreshExpiry() {
    return _localStore.getItem("refresh_token_expiry");
  }

  static setAccessExpiry(date) {
    _localStore.setItem("access_token_expiry", date);
  }

  static getAccessExpiry() {
    return _localStore.getItem("access_token_expiry");
  }
}
